<div>

	<!------------------------------>
	<!-- Tree Section-->
	<!------------------------------>
	<section style="width: 50%; float: left;" class="border-right"
					 (gdOutsideClick)="onOutsideClick($event)">

		<!------------------------------>
		<!-- Create Benefit/Limit Dialog Buttons-->
		<!------------------------------>
		<ng-container [ngTemplateOutlet]="createBenefitAndLimitButtons"></ng-container>

		<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">

			<!------------------------------>
			<!-- Add Benefit Input Field -->
			<!------------------------------>
			<mat-tree-node *matTreeNodeDef="let node; when: hasNoContentAndLevelBenefit" matTreeNodePadding>
				<mat-form-field>
					<mat-label>Add Benefit</mat-label>
					<input matInput type="text" placeholder="Search for a benefit by name"
								 (input)="benefitByNameOrByBenefitCodeTextChanged$.next($any($event.target).value)"
								 [matAutocomplete]="benefitsAuto">
					<mat-autocomplete #benefitsAuto="matAutocomplete" [panelWidth]="'40vw'">
						<mat-option *ngFor="let benefit of filteredBenefits"
												[value]="benefit.name"
												(onSelectionChange)="onBenefitSelectionChanged(benefit, node)">
							{{getBenefitDisplayName(benefit, false)}}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
				<button class="delete-icon" mat-icon-button (click)="deleteItem(node)">
					<mat-icon>delete</mat-icon>
				</button>
			</mat-tree-node>

			<!------------------------------>
			<!-- Limit Level Input Field-->
			<!------------------------------>
			<mat-tree-node *matTreeNodeDef="let node; when: hasNoContentAndLevelLimit" matTreeNodePadding>
				<mat-form-field>
					<mat-label>Add Limit</mat-label>
					<input matInput type="text" placeholder="Search for a limit by name"
								 (input)="limitTextChanged$.next($any($event.target).value)"
								 [matAutocomplete]="benefitsAuto">
					<mat-autocomplete #benefitsAuto="matAutocomplete" [panelWidth]="'40vw'">
						<mat-option *ngFor="let limit of filteredLimits"
												[value]="limit.name"
												(onSelectionChange)="onLimitSelectionChanged(limit, node)">
							{{getLimitDisplayName(limit)}}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
				<button class="delete-icon" mat-icon-button (click)="deleteItem(node)">
					<mat-icon>delete</mat-icon>
				</button>
			</mat-tree-node>

			<!------------------------------>
			<!--Product -> (Has Children) -> Benefits-->
			<!------------------------------>
			<mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
				<button mat-icon-button matTreeNodeToggle
								[attr.aria-label]="'Toggle ' + node.item">
					<mat-icon class="mat-icon-rtl-mirror"
										(click)="onBenefitNodeClicked(node)">
						{{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
					</mat-icon>
				</button>

				<div gdTooltip
						 [ngClass]="{
             'hand-cursor p-l-15 p-r-15': node.level === treeLevel.BenefitLevel,
             'background-highlight': node.item.includes(selectedBenefit?.name)
             }"
						 (click)="onBenefitNodeClicked(node)">
					<p class="m-b-0" [innerHTML]="node.item"></p>
					
					<ng-template #tooltipTemplate>
						<div *ngIf="getBenefitDisplayNameForToolTip(node).length > MIN_CHARS_LENGTH_AFTER_TOOLTIP_TO_VISIBLE"
								 class="tooltip">
							<p class="m-b-0" [innerHTML]="getBenefitDisplayNameForToolTip(node)"></p>
						</div>
					</ng-template>
				</div>

				<button mat-icon-button (click)="addNewItem(node)">
          <mat-icon [matTooltip]="getTreeTooltip(node, modeType.Add)">
            add
          </mat-icon>
				</button>

				<!-- Note: Hide Delete button for Product -->
				<button *ngIf="node.level === treeLevel.BenefitLevel" class="delete-icon" mat-icon-button
								(click)="deleteItem(node)">
          <mat-icon [matTooltip]="getTreeTooltip(node, modeType.Delete)">delete</mat-icon>
				</button>
			</mat-tree-node>

			<!------------------------------>
			<!-- Leaf Nodes (Limits)-->
			<!------------------------------>
			<mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
				<button mat-icon-button disabled></button>
				{{node.item}}
				<button class="delete-icon" mat-icon-button (click)="deleteItem(node)">
          <mat-icon [matTooltip]="getTreeTooltip(node, modeType.Delete)">delete</mat-icon>
				</button>
			</mat-tree-node>
		</mat-tree>
	</section>

	<!------------------------------>
	<!-- Form Section-->
	<!------------------------------>


	<ng-container *ngIf="showConfigurationSection else placeholder">
		<section class="configuration-section"
						 style="width: 48%; float: right;padding-left: 25px;">
			<!------------------------------>
			<!-- Form Section-->
			<!------------------------------>
			<form [formGroup]="benefitLimitsFormGroup">
				<!--Parent Benefit-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Parent Benefit</mat-label>
							<input matInput type="text" [required]="isParentBenefitRequired"
                     [formControlName]="controls.ParentBenefit"
										 placeholder="Search for a benefit by name"
										 (input)="benefitByNameOrByBenefitCodeTextChanged$.next($any($event.target).value)"
										 (blur)="onBlurParentBenefit()"
										 [matAutocomplete]="parentBenefitsAuto" >
							<mat-autocomplete #parentBenefitsAuto="matAutocomplete" [panelWidth]="'40vw'">
								<mat-option *ngFor="let benefit of filteredBenefits"
														[value]="benefit.name"
														(onSelectionChange)="onPBLConfigurationBenefitSelectionChanged(benefit, controls.ParentBenefit)">
									{{getBenefitDisplayName(benefit, false)}}
								</mat-option>
							</mat-autocomplete>

							<button *ngIf="benefitLimitsFormGroup.get(controls.ParentBenefit).value"
											(click)="clearParentBenefit()"
											aria-label="Clear" mat-button mat-icon-button matSuffix>
								<mat-icon style="color: grey;">clear</mat-icon>
							</button>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.ParentBenefit)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>


				<!--First Alternative benefit-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>First Alternative Benefit</mat-label>
							<input matInput type="text" [formControlName]="controls.FirstAlternativeBenefit"
										 placeholder="Search for a benefit by name"
										 (input)="benefitByNameOrByBenefitCodeTextChanged$.next($any($event.target).value)"
										 (blur)="onBlurFirstAlternativeBenefit()"
										 [matAutocomplete]="firstAlternateBenefitsAuto">
							<mat-autocomplete #firstAlternateBenefitsAuto="matAutocomplete" [panelWidth]="'40vw'">
								<mat-option *ngFor="let benefit of filteredBenefits"
														[value]="benefit.name"
														(onSelectionChange)="onPBLConfigurationBenefitSelectionChanged(benefit, controls.FirstAlternativeBenefit)">
									{{getBenefitDisplayName(benefit, false)}}
								</mat-option>
							</mat-autocomplete>

							<button *ngIf="benefitLimitsFormGroup.get(controls.FirstAlternativeBenefit).value"
											(click)="clearFirstAlternativeBenefit()"
											aria-label="Clear" mat-button mat-icon-button matSuffix>
								<mat-icon style="color: grey;">clear</mat-icon>
							</button>
						</mat-form-field>

						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.FirstAlternativeBenefit)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Second Alternative benefit-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Second Alternative Benefit</mat-label>
							<input matInput type="text" [formControlName]="controls.SecondAlternativeBenefit"
										 placeholder="Search for a benefit by name"
										 (input)="benefitByNameOrByBenefitCodeTextChanged$.next($any($event.target).value)"
										 (blur)="onBlurSecondAlternativeBenefit()"
										 [matAutocomplete]="secondAlternateBenefitsAuto">
							<mat-autocomplete #secondAlternateBenefitsAuto="matAutocomplete" [panelWidth]="'40vw'">
								<mat-option *ngFor="let benefit of filteredBenefits"
														[value]="benefit.name"
														(onSelectionChange)="onPBLConfigurationBenefitSelectionChanged(benefit, controls.SecondAlternativeBenefit)">
									{{getBenefitDisplayName(benefit, false)}}
								</mat-option>
							</mat-autocomplete>
							<button *ngIf="benefitLimitsFormGroup.get(controls.SecondAlternativeBenefit).value"
											(click)="clearSecondAlternativeBenefit()"
											aria-label="Clear" mat-button mat-icon-button matSuffix>
								<mat-icon style="color: grey;">clear</mat-icon>
							</button>
						</mat-form-field>

						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.SecondAlternativeBenefit)">
							help_outline
						</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Co-Payment Percentage-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Co-Payment Percentage</mat-label>
							<input matInput type="text" [formControlName]="controls.CoPaymentPercentage"
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurFixedTo2DecimalPlace(controls.CoPaymentPercentage)">
							<span matSuffix>%</span>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.CoPaymentPercentage)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Percentage of Payer Rate Name-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Percentage of Payer Rate</mat-label>
							<input matInput [formControlName]="controls.PercentageOfPayerRate"
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurFixedTo2DecimalPlace(controls.PercentageOfPayerRate)">
              <span matSuffix>%</span>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.PercentageOfPayerRate)">
							help_outline
						</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Deductible Amount-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Deductible Amount</mat-label>
							<input matInput [formControlName]="controls.Deductible"
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurFixedTo2DecimalPlace(controls.Deductible)">
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.Deductible)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--General Waiting Period-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>General Waiting Period</mat-label>
							<input matInput [formControlName]="controls.WaitingPeriod"
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurTruncateDecimalPart(controls.WaitingPeriod)">
							<span matSuffix>Days</span>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.WaitingPeriod)">help_outline
						</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--PEC Waiting Period-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>PEC Waiting Period</mat-label>
							<input matInput [formControlName]="controls.PecWaitingPeriod"
                     mask="separator.2" thousandSeparator=","
                     (blur)="onBlurTruncateDecimalPart(controls.PecWaitingPeriod)">
							<span matSuffix>Days</span>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.PecWaitingPeriod)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Start Date-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>Start Date</mat-label>
							<!--HERE IT SHOULD BE END DATE FOR VALIDATION PURPOSE-->
							<input [formControlName]="controls.StartDate" required
										 [matDatepicker]="startDateDatePickerStep2" matInput
										 [max]="benefitLimitsFormGroup.get(controls.EndDate).value">
							<mat-datepicker-toggle [for]="startDateDatePickerStep2" matIconSuffix>
							</mat-datepicker-toggle>
							<mat-datepicker #startDateDatePickerStep2></mat-datepicker>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.StartDate)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--End Date-->
				<mat-grid-list cols="1" rowHeight="75px">
					<mat-grid-tile>
						<mat-form-field class="w-60">
							<mat-label>End Date</mat-label>
							<!--HERE IT SHOULD BE START DATE FOR VALIDATION PURPOSE-->
							<input [formControlName]="controls.EndDate"
										 [matDatepicker]="endDateDatePickerStep2" matInput required
										 [min]="benefitLimitsFormGroup.get(controls.StartDate).value">
							<mat-datepicker-toggle [for]="endDateDatePickerStep2" matIconSuffix>
							</mat-datepicker-toggle>
							<mat-datepicker #endDateDatePickerStep2></mat-datepicker>
						</mat-form-field>
						<mat-icon class="info-icon" [matTooltip]="getInfoTooltip(toolTipControls.EndDate)">help_outline</mat-icon>
					</mat-grid-tile>
				</mat-grid-list>

				<!--Save Button-->
				
				<div class="flex justify-center">
					<button mat-raised-button matStepperNext color="warn"
									(click)="onCancel()">
						Cancel
					</button>
					<button mat-raised-button matStepperNext color="primary"
									[disabled]="!isFormValid"
									(click)="onSavePBLConfigurations()">
						Save
					</button>
				</div>
			</form>
		</section>

	</ng-container>

	<!-- Placeholder Section-->
	<ng-template #placeholder>
		<section style="width: 48%; float: right;padding-left: 25px;">
			<div class="mat-primary-color text-center">
				<label>Select a benefit from the tree on the left to view additional fields</label>
			</div>
		</section>
	</ng-template>
</div>


<div class="button-container">
	<button mat-raised-button matStepperPrevious color="primary"
          (click)="onBack()">Back</button>
	<button mat-raised-button color="warn" (click)="resetFormGroup();">Clear</button>
	<button mat-raised-button matStepperNext color="primary"
					[disabled]="isNotAllowedToSaveProductWhen"
					(click)="onFinishAndSaveProduct()">
		Finish
    <mat-icon *ngIf="isNotAllowedToSaveProductWhen"
      class="info-icon" [matTooltip]="getMatTooltipText">
      help_outline
    </mat-icon>
	</button>
</div>


<!--Note:-->
<!-- Intentionally Created Template to avoid Code Cluttering-->
<ng-template #createBenefitAndLimitButtons>
	<!-- Create buttons -->
	<div class="flex">
		<button class="m-r-10" mat-raised-button color="warn" (click)="openBenefitDialog()">
			<mat-icon>add</mat-icon>
			Create New Benefit
		</button>

		<button mat-raised-button color="warn" (click)="openLimitDialog()">
			<mat-icon>add</mat-icon>
			Create New Limit
		</button>
	</div>
</ng-template>

